{isCordova} = require 'config'

module.exports = (text) ->
  return new Promise (resolve, reject) ->
    if isCordova and cordovaConfirm = navigator.notification?.confirm
      cordovaConfirm(text, (keyIndex) -> resolve(keyIndex is 1))
    else
      resolve(window.confirm(text))
